import { memo } from 'react';

import { FileStatusIconProgressing, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type AssetTaggingTaskInProgressPanelItemProps = {
  onCancel: () => void;
};

export const AssetTaggingTaskInProgressPanelItem = memo(({ onCancel }: AssetTaggingTaskInProgressPanelItemProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();

  return (
    <PaneItemTW
      avatar={<FileStatusIconProgressing size={getTaskPaneFileStatusIconSize(ui2026)} />}
      title={
        <FileStatusTitle data-testid="ASSET_TAGGING_TASK_IN_PROGRESS_PANEL_ITEM_TITLE">
          {ui2026 ? 'Updating tags…' : 'Updating tags'}
        </FileStatusTitle>
      }
      subtitle={
        ui2026 ? undefined : (
          <FileStatusSubtitle className="truncate">Your tags will be applied shortly.</FileStatusSubtitle>
        )
      }
      buttons={<TaskPaneDismissButton label="Cancel" onClick={onCancel} />}
    />
  );
});

AssetTaggingTaskInProgressPanelItem.displayName = 'AssetTaggingTaskInProgressPanelItem';
